import metaTag from '~~/goodall/client-nuxt/meta-tag';

export const createFeatureRunningGetter = (store) => (name) => (store.getters['goodall/getFeature'](name) || false);
export const createTrackExperimentGetter = (store) => (name) => (store.getters['goodall/getExperiment'](name) || '');
export const createTrackExperimentsGetter = (store) => (names) => (names.map((name) => (
  store.getters['goodall/getExperiment'](name) || ''),
));

export default ({ store }, inject) => {
  inject('featureRunning', createFeatureRunningGetter(store));
  inject('trackExperiment', createTrackExperimentGetter(store));
  inject('trackExperiments', createTrackExperimentsGetter(store));
  inject('getGoodallMetaTag', metaTag(store));
};
